export default {
  codes: {},
  mapCodesByGrpId: {},
  modalAlert: { showModal: false, message: "" },
};
